import React, { useState } from "react";
import { Card, DateBadge, Grid, Icon, InputText, Link, Text } from "~/components-shared";
import moment from "moment/moment";
import { useTranslation } from "react-i18next";
import styled, { useTheme } from "styled-components";
const StyledGrid = styled(Grid)`
  max-height: 300px;
  overflow: auto;
`;
const TopicSummaryMeetingsCard = _ref => {
  let {
    events,
    initialUpcomingLimit = 1,
    initialPastLimit = 3,
    ...rest
  } = _ref;
  const {
    colors
  } = useTheme();
  const {
    t
  } = useTranslation();
  const [upcomingLimit, setUpcomingLimit] = useState(initialUpcomingLimit);
  const [pastLimit, setPastLimit] = useState(initialPastLimit);
  const [upcomingQuery, setUpcomingQuery] = useState("");
  const [pastQuery, setPastQuery] = useState("");
  let tempUpcomingEvents = events.filter(event => moment(event.dateFrom).valueOf() > moment().valueOf()).sort((a, b) => moment(a.dateFrom).valueOf() - moment(b.dateFrom).valueOf());
  let tempPastEvents = events.filter(event => moment(event.dateFrom).valueOf() <= moment().valueOf()).sort((a, b) => moment(b.dateFrom).valueOf() - moment(a.dateFrom).valueOf());
  if (!tempPastEvents.length && !tempUpcomingEvents.length) {
    return null;
  }
  const exceededUpcomingLimit = tempUpcomingEvents.length > initialUpcomingLimit;
  const exceededUpcomingLimitBy = upcomingLimit && tempUpcomingEvents.length > upcomingLimit ? tempUpcomingEvents.length - upcomingLimit : undefined;
  const exceededPastLimit = tempPastEvents.length > initialPastLimit;
  const exceededPastLimitBy = pastLimit && tempPastEvents.length > pastLimit ? tempPastEvents.length - pastLimit : undefined;
  if (exceededUpcomingLimitBy) {
    tempUpcomingEvents = tempUpcomingEvents.slice(0, upcomingLimit);
  }
  if (exceededPastLimitBy) {
    tempPastEvents = tempPastEvents.slice(0, pastLimit);
  }
  const togglePastLimit = () => {
    setPastLimit(prev => prev ? undefined : initialPastLimit);
    setPastQuery("");
  };
  const toggleUpcomingLimit = () => {
    setUpcomingLimit(prev => prev ? undefined : initialUpcomingLimit);
    setUpcomingQuery("");
  };
  const filteredPastEvents = tempPastEvents.filter(_ref2 => {
    let {
      name
    } = _ref2;
    return pastQuery === "" || name.toLowerCase().includes(pastQuery.toLowerCase());
  });
  const filteredUpcomingEvents = tempUpcomingEvents.filter(_ref3 => {
    let {
      name
    } = _ref3;
    return upcomingQuery === "" || name.toLowerCase().includes(upcomingQuery.toLowerCase());
  });
  return /*#__PURE__*/React.createElement(Card, rest, !!filteredUpcomingEvents.length && /*#__PURE__*/React.createElement(React.Fragment, null, !!filteredPastEvents.length && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    weight: "semiBold",
    s: {
      mb: 3
    }
  }, "Upcoming"), exceededUpcomingLimit && !exceededUpcomingLimitBy && /*#__PURE__*/React.createElement(InputText, {
    autoFocus: true,
    value: upcomingQuery,
    onChange: val => setUpcomingQuery(val),
    elemBefore: /*#__PURE__*/React.createElement(Icon, {
      src: "search",
      s: {
        mr: 2
      }
    }),
    placeholder: t("common.actions.search"),
    fullWidth: true,
    clearButton: true,
    s: {
      mb: 4
    }
  }), filteredUpcomingEvents.length ? /*#__PURE__*/React.createElement(StyledGrid, {
    cols: 1,
    gap: 4
  }, filteredUpcomingEvents.map(event => /*#__PURE__*/React.createElement(Grid, {
    key: event.id,
    cols: 2,
    template: "4rem 1fr",
    gap: 4
  }, /*#__PURE__*/React.createElement(DateBadge, {
    date: event.dateFrom
  }), /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Link, {
    weight: "semiBold",
    href: event.url,
    color: colors.text.primary,
    fontSize: 4,
    display: "block",
    s: {
      mb: 1
    }
  }, event.name), /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    weight: "semiBold",
    display: "block",
    s: {
      mb: 1
    }
  }, t("TopicSummaryCard.startsAt"), " ", moment(event.dateFrom).format("hh:mma"), " for", " ", moment.duration(moment(event.dateFrom).diff(moment(event.dateTo))).humanize()), /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    weight: "semiBold"
  }, t("TopicSummaryCard.footprints", {
    count: event.footprintCount
  })))))) : /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    weight: "semiBold",
    fontSize: 4,
    s: {
      my: 2
    }
  }, "No events"), exceededUpcomingLimit && /*#__PURE__*/React.createElement(Link, {
    onClick: toggleUpcomingLimit,
    s: {
      mt: 2
    },
    weight: "semiBold",
    color: colors.text.secondary,
    underline: true
  }, exceededUpcomingLimitBy ? `Show ${exceededUpcomingLimitBy} more` : "Collapse list")), !!tempPastEvents.length && /*#__PURE__*/React.createElement(React.Fragment, null, !!tempUpcomingEvents.length && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    weight: "semiBold",
    s: {
      my: 3
    }
  }, "Past"), exceededPastLimit && !exceededPastLimitBy && /*#__PURE__*/React.createElement(InputText, {
    autoFocus: true,
    value: pastQuery,
    onChange: val => setPastQuery(val),
    elemBefore: /*#__PURE__*/React.createElement(Icon, {
      src: "search",
      s: {
        mr: 2
      }
    }),
    placeholder: t("common.actions.search"),
    fullWidth: true,
    clearButton: true,
    s: {
      mb: 4
    }
  }), filteredPastEvents.length ? /*#__PURE__*/React.createElement(StyledGrid, {
    cols: 1,
    gap: 4
  }, filteredPastEvents.map(event => /*#__PURE__*/React.createElement(Grid, {
    key: event.id,
    cols: 2,
    template: "4rem 1fr",
    gap: 4
  }, /*#__PURE__*/React.createElement(DateBadge, {
    date: event.dateFrom
  }), /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Link, {
    weight: "semiBold",
    href: event.url,
    color: colors.text.primary,
    fontSize: 4,
    display: "block",
    s: {
      mb: 1
    }
  }, event.name), /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    weight: "semiBold",
    display: "block",
    s: {
      mb: 1
    }
  }, t("TopicSummaryCard.startsAt"), " ", moment(event.dateFrom).format("hh:mma"), " for", " ", moment.duration(moment(event.dateFrom).diff(moment(event.dateTo))).humanize()), /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    weight: "semiBold"
  }, t("TopicSummaryCard.footprints", {
    count: event.footprintCount
  })))))) : /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    weight: "semiBold",
    fontSize: 4,
    s: {
      my: 2
    }
  }, "No events"), exceededPastLimit && /*#__PURE__*/React.createElement(Link, {
    onClick: togglePastLimit,
    s: {
      mt: 2
    },
    weight: "semiBold",
    color: colors.text.secondary,
    underline: true
  }, exceededPastLimitBy ? `Show ${exceededPastLimitBy} more` : "Collapse list")));
};
export default TopicSummaryMeetingsCard;